import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 4 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M2 4a2 2 0 1 1 0-4 2 2 0 0 1 0 4M2 10a2 2 0 1 1 0-4 2 2 0 0 1 0 4M2 16a2 2 0 1 1 0-4 2 2 0 0 1 0 4"
    }, null, -1)
  ]))]))
}
export default { render: render }